import { render } from "./asset-list.vue?vue&type=template&id=a6907554"
import script from "./asset-list.vue?vue&type=script&lang=js"
export * from "./asset-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__